import React, { useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import LightboxReact from "lightbox-react"
// import LightboxReact from "react-image-lightbox"
// import "lightbox-react/style.css"

const useGallery = ({ pictures }) =>
  pictures.nodes.map(node => ({
    ...node.childImageSharp,
    // Note that we're spreading the childImageSharp object here
    id: node.id,
    imgSrc: node.childImageSharp.gatsbyImageData.images.fallback.src,
  }))

const Gallery = data => {
  const images = useGallery(data)
  const [showLightbox, setShowLightbox] = useState(false)
  const [selectedImage, setSelectedImage] = useState(0)

  const handleOpen = i => e => {
    setShowLightbox(true)
    setSelectedImage(i)
  }

  const handleClose = () => {
    setShowLightbox(false)
  }

  const handlePrevRequest = (i, length) => e => {
    setSelectedImage((i - 1 + length) % length)
  }
  const handleNextRequest = (i, length) => e => {
    setSelectedImage((i + 1) % length)
  }

  return (
    <div className="gallery">
      {images.map(({ id, gatsbyImageData }, i) => (
        <button key={id} className="button_noStyle" onClick={handleOpen(i)}>
          <GatsbyImage
            image={gatsbyImageData}
            style={{}}
            alt={id}
            className="gallery_image"
          />
        </button>
      ))}

      {showLightbox && (
        <LightboxReact
          enableZoom={false}
          clickOutsideToClose={true}
          mainSrc={images[selectedImage].imgSrc}
          nextSrc={images[(selectedImage + 1) % images.length].imgSrc}
          prevSrc={
            images[(selectedImage + images.length - 1) % images.length].imgSrc
          }
          onCloseRequest={handleClose}
          onMovePrevRequest={handlePrevRequest(selectedImage, images.length)}
          onMoveNextRequest={handleNextRequest(selectedImage, images.length)}
        />
      )}
    </div>
  )
}

export default Gallery
